import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { CreateScreeningAppointment } from '@shared/services/healthiersg/records/types/getScreeningRecommended';

import type { HealthierSGAppt } from './healthierSGAppt.types';

const initialState: HealthierSGAppt = {
  isFromHSGRequestFormPage: false,
  isHsgVaccinationAppt: false,
  isHsgConsultationAppt: false,
  isHsgScreeningAppt: false,
  isFromHSGJourneyReadyToBookPage: false,
  isFromHSGLocationSelectionPage: false,
};

const healthierSGApptSlice = createSlice({
  initialState,
  name: 'healthierSGAppt',
  reducers: {
    resetIsFromHSGRequestFormPage(state) {
      state.isFromHSGRequestFormPage = false;
    },
    resetIsHsgVaccinationAppt(state) {
      state.isHsgVaccinationAppt = false;
    },
    resetIsHsgScreeningAppt(state) {
      state.isHsgScreeningAppt = false;
    },
    resetHSGScreeningAppointment(state) {
      state.hsgScreeningAppointment = undefined;
    },
    resetHSGColorectalFormValues(state) {
      state.hsgColorectalFormValues = undefined;
    },
    setIsFromHSGRequestFormPage(state, action: PayloadAction<boolean>) {
      state.isFromHSGRequestFormPage = action.payload;
    },
    setIsHsgVaccinationAppt(state, action: PayloadAction<boolean>) {
      state.isHsgVaccinationAppt = action.payload;
    },
    setIsHsgScreeningAppt(state, action: PayloadAction<boolean>) {
      state.isHsgScreeningAppt = action.payload;
    },
    setNewHSGScreeningAppointment(state, action: PayloadAction<CreateScreeningAppointment>) {
      state.hsgScreeningAppointment = {
        ...state.hsgScreeningAppointment,
        ...action.payload,
      };
    },
    setFromHSGJourneyReadyToBookPage(state, action: PayloadAction<boolean>) {
      state.isFromHSGJourneyReadyToBookPage = action.payload;
    },
    setFromHSGLocationSelectionPage(state, action: PayloadAction<boolean>) {
      state.isFromHSGLocationSelectionPage = action.payload;
    },
    setHSGColorectalFormValues(state, action: PayloadAction<Record<string, string>>) {
      state.hsgColorectalFormValues = action.payload;
    },
    resetIsFromHSGLocationSelectionPage(state) {
      state.isFromHSGLocationSelectionPage = false;
    },
  },
});

export const { actions: healthierSGApptAction } = healthierSGApptSlice;

export default healthierSGApptSlice.reducer;
